import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { FeatureFlagService } from '@core/services/feature-flag.service';

/**
 * Garantit que les feature flags sont chargés avant l'activation des routes protégées,
 * pour que isEnabledSync renvoie la vraie valeur (et non le défaut) dès le premier rendu.
 * À placer après authWithRedirectGuard (le chargement requiert un utilisateur authentifié).
 */
export const featureFlagsLoadedGuard: CanActivateFn = (): Observable<boolean> => {
  const featureFlagService = inject(FeatureFlagService);

  return featureFlagService.ensureLoaded();
};
